'use strict';
import Component from 'gia/Component';

export default class HomeView extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element;
    this.DOM.strates = this.DOM.view.querySelectorAll('.js-strate')

    //! Fns
    this.renderStrates()
  }

  renderStrates()
  {
    for(let [i,strate] of this.DOM.strates.entries()) {
      let number = (i+1).toString().padStart(2,'0')
      strate.innerHTML = number
    }
  }
}
